module.exports = __webpack_public_path__ + "img/icon_wallet_lock.a7617427.svg";